// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"schedule_mainContainer__3RvQh","illustration":"schedule_illustration__1ySKc"};